﻿import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet.fullscreen';
import 'leaflet.fullscreen/Control.FullScreen.css';

function initializeLeafletMap(mapContainer, norKartApiKey) {
    // mapContainer resolves to null when the referenced element has been detached
    // (navigation / re-render) before this interop call runs. Bail out quietly.
    if (mapContainer == null) {
        return null;
    }

    // Create the map
    console.log(norKartApiKey)
    let map = L.map(mapContainer, {
        minZoom: 3,
        maxZoom: 19
    }).setView([58.969057, 5.729007], 13); // Set a default position and zoom level

    // Add base layers
    let baseLayers = (norKartApiKey !== '') ? {
            'Kart': L.tileLayer.webatlas({
                mapType: L.TileLayer.Webatlas.Type.VECTOR,
                apikey: norKartApiKey
            }).addTo(map),
            'Foto': L.tileLayer.webatlas({
                mapType: L.TileLayer.Webatlas.Type.AERIAL,
                apikey: norKartApiKey
            }),
            'Hybrid': L.tileLayer.webatlas({
                mapType: L.TileLayer.Webatlas.Type.HYBRID,
                apikey: norKartApiKey
            }),
            'OpenStreetMap': L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                maxZoom: 19,
                attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
            }),
        }
        : {};

    if (Object.keys(baseLayers).length > 0) {
        L.control.layers(baseLayers).addTo(map);
    }

    // Fallback to OpenStreetMap as main tile layer when no other base layers is defined
    if (Object.keys(baseLayers).length === 0) {
        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        }).addTo(map);
    }

    map.addControl(new L.control.fullscreen({
        title: 'Gå inn i fullskjerm-modus',
        titleCancel: 'Gå ut av fullskjerm-modus',
        forceSeparateButton: true
    }));

    mapContainer._leafletMap = map;
    mapContainer._markers = [];
    mapContainer._markerClusterGroup = L.markerClusterGroup();

    // Return the map instance
    return map;
}

function toggleMarkers(mapContainer, pinListData, groupId, hashId, setPinsStatus) {
    // mapContainer resolves to null when the referenced element has been detached
    // (navigation / re-render) before this interop call runs. Bail out quietly.
    if (mapContainer == null || mapContainer._leafletMap == null) {
        return;
    }
    const map = mapContainer._leafletMap;
    let markers = mapContainer._markers;
    let markerClusterGroup = mapContainer._markerClusterGroup;
    const button = document.querySelector(
        `input[data-group-id="${groupId}"][id="${hashId}"]`
    );
    let allButtons = document.querySelectorAll(
        `[id="${hashId}"]`
    );
    allButtons = Array.from(allButtons);
    let hiddenMarkerGroupButtons = allButtons.filter((button) => button.getAttribute('data-group-id') !== `${groupId}` && button.getAttribute('data-displaying') === 'false');
    hiddenMarkerGroupButtons = hiddenMarkerGroupButtons.map((button) =>
        parseInt(button.getAttribute('data-group-id'))
    );
    const displayingGroup = button.getAttribute("data-displaying") === "true";

    if (setPinsStatus) {
        markers = pinListData.filter((marker) => !(marker.markerGroupId === groupId || hiddenMarkerGroupButtons.includes(marker.markerGroupId)));
        setPins(mapContainer, markers);
    }

    let newMarkers = [];
    const pinsGrouped = pinListData.filter((pinData) => ("markerGroupId" in pinData && pinData.markerGroupId === groupId));

    if (!displayingGroup) {
        button.setAttribute("data-displaying", true.toString());
        newMarkers = getNewMarkers(mapContainer, pinsGrouped);
        mapContainer._markers = [...mapContainer._markers, ...newMarkers];

    } else {
        markers = mapContainer._markers;
        button.setAttribute("data-displaying", "false");

        if (markerClusterGroup != null) {
            markerClusterGroup.clearLayers();
            map.removeLayer(markerClusterGroup);
        }

        mapContainer._markers = markers.filter((marker) => marker.options.groupId !== groupId);
        markerClusterGroup = L.markerClusterGroup();
        markerClusterGroup.addLayers(mapContainer._markers);


    }
    map.whenReady(function () {
        map.addLayer(markerClusterGroup);
        fitMapToMarkers(map, mapContainer._markers);
    });
    mapContainer._markerClusterGroup = markerClusterGroup;
}

// Function to add a pins to the map
function setPins(mapContainer, pins) {
    // mapContainer resolves to null when the referenced element has been detached
    // (navigation / re-render) before this interop call runs. Bail out quietly.
    if (mapContainer == null || mapContainer._leafletMap == null) {
        return;
    }
    const map = mapContainer._leafletMap;
    let markerClusterGroup = mapContainer._markerClusterGroup;

    if (markerClusterGroup != null) {
        markerClusterGroup.clearLayers();
        map.removeLayer(markerClusterGroup);
    }
    
    let markers = getNewMarkers(mapContainer, pins);

    // Add markers and fit map to markers
    map.whenReady(function () {
        map.addLayer(markerClusterGroup);
        if (markers.length > 0) {
            let group = new L.featureGroup(markers);
            map.fitBounds(group.getBounds());
        }
    });
    mapContainer._markers = markers;
    mapContainer._markerClusterGroup = markerClusterGroup;

}

function GetPinIcon(icon, markerCss) {
    if (icon != null || icon === "") {
        icon = new L.divIcon({
            className: markerCss + " leaflet-marker-size",
            html: icon
        });
    } else {
        icon = L.icon({
            iconUrl: "/static/gfx/icons/sk-map-pin.svg"
        });
    }
    return icon;
}

function getNewMarkers(mapContainer, pins) {
    const map = mapContainer._leafletMap;
    let markerClusterGroup = mapContainer._markerClusterGroup;
    let newMarkers = [];

    pins.forEach(function (pinData) {

        if (!pinData.coordinate)
            return;

        const icon = GetPinIcon(pinData.markerSvg,pinData.markerColor);
        
        // Create a marker for the pin
        let marker = L.marker(
            [pinData.coordinate.latitude, pinData.coordinate.longitude],
            {title: pinData.title, groupId: pinData.markerGroupId, icon: icon});


        markerClusterGroup.addLayer(marker);

        newMarkers.push(marker);

        // Create a list of polygons if it's specified
        let polygons = [];
        if (pinData.polygons) {
            pinData.polygons.forEach(function (polygon) {
                let polygonLayer;

                if (polygon) {
                    const polygonPoints = polygon.map(function (latlng) {
                        return [latlng.latitude, latlng.longitude];
                    });

                    polygonLayer = L.polygon(polygonPoints, {color: 'blue'});
                    polygonLayer.addTo(map);

                    map.on('click', function () {
                        polygonLayer.remove();
                    });

                    polygonLayer.setVisible = function (visible) {
                        if (visible) {
                            if (!map.hasLayer(polygonLayer)) {
                                polygonLayer.addTo(map);
                            }
                        } else {
                            if (map.hasLayer(polygonLayer)) {
                                map.removeLayer(polygonLayer);
                            }
                        }
                    };

                    // Initially hide the polygon
                    polygonLayer.setVisible(false);
                }
                polygons.push(polygonLayer);
            })
        }
        if (pinData.infoBoxHtml) {
            let popup = L.popup({
                closeOnClick: true,
                autoClose: false
            }).setContent(pinData.infoBoxHtml);

            marker.bindPopup(popup);
        }
        marker.on('click', function () {
            if (polygons) {
                polygons.forEach(function (polygon) {
                    const isVisible = map.hasLayer(polygon);
                    polygon.setVisible(!isVisible);
                })
            }
        });
    });
    return newMarkers;
}

function fitMapToMarkers(map, markers) {
    if (markers.length > 0) {
        let group = new L.featureGroup(markers);
        map.fitBounds(group.getBounds());
    }
}

window.initializeLeafletMap = initializeLeafletMap;
window.toggleMarkers = toggleMarkers;
window.setPins = setPins;
window.GetPinIcon = GetPinIcon;
window.getNewMarkers = getNewMarkers;
window.fitMapToMarkers = fitMapToMarkers;
